export default __webpack_public_path__ + "static/img5_final-8e2ca28905071cc57602e693e062af68.png";